import * as yup from "yup";
import BaseForm from "../../../../../../shared/components/form/BaseForm";
import FormDatePicker from "../../../../../../shared/components/datepicker/FormDatePicker";
import { useTranslation } from "react-i18next";
import { Label } from "../../../../../../shared/components/label/Label";
import { Input } from "../../../../../../shared/components/input/Input";
import { useState } from "react";

const EditPeriodForm = ({ onSubmitHandler, trackerGoal, period }) => {
  const { t } = useTranslation();
  const validationSchema = yup.object({
    beginDate: yup
      .date()
      .required(
        t("objectivesTracker.editPeriodForm.fields.beginDate.required"),
      ),
    endDate: yup
      .date()
      .required(t("objectivesTracker.editPeriodForm.fields.endDate.required")),
  });

  const defaultValues = {
    beginDate: new Date(period?.beginDate),
    endDate: new Date(period?.endDate),
  };

  const [ratio, setRatio] = useState(
    (period?.result?.goal / trackerGoal) * 100.0,
  );
  const [goal, setGoal] = useState(period?.result?.goal);

  const onGoalChangeHandler = (e) => {
    const goalToReachValue = +e.target.value;
    const ratioToReachValue = (goalToReachValue / trackerGoal) * 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onRatioChangeHandler = (e) => {
    const ratioToReachValue = +e.target.value;
    const goalToReachValue = (trackerGoal * ratioToReachValue) / 100.0;
    setGoal(goalToReachValue);
    setRatio(ratioToReachValue);
  };

  const onSubmit = (formValues) => {
    onSubmitHandler({ ...formValues, goal: goal });
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmit}
      isCreationForm={false}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormDatePicker
            name="beginDate"
            label={t("objectivesTracker.editPeriodForm.fields.beginDate.label")}
            required
          />
        </div>
        <div className="w-1/2">
          <FormDatePicker
            name="endDate"
            label={t("objectivesTracker.editPeriodForm.fields.endDate.label")}
            required
          />
        </div>
      </div>
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.editPeriodForm.fields.goal.label")}
          </Label>
          <Input type="number" onChange={onGoalChangeHandler} value={goal} />
        </div>
        <div className="w-1/2">
          <Label>
            {t("objectivesTracker.editPeriodForm.fields.ratio.label")}
          </Label>
          <Input type="number" onChange={onRatioChangeHandler} value={ratio} />
        </div>
      </div>
    </BaseForm>
  );
};

export default EditPeriodForm;
